<label class="component-toggleAdvanced">
    <span *ngIf="!tooltip" class="toggleMessage">{{message}}</span>
    <ca-absolute-tooltip
        *ngIf="tooltip && tooltipType != 'icon'"
        [content]="tooltip"
        type="text-plain"
        position="top-left">
        <span class="toggleMessage">{{message}}</span>
    </ca-absolute-tooltip>
    <span *ngIf="tooltip && tooltipType == 'icon'">
        {{message}}
        <ca-absolute-tooltip
            [content]="tooltip"
            type="icon-info"
            position="top-left">
        </ca-absolute-tooltip>
    </span>
    <input type="checkbox" [name]="toggleName" [(ngModel)]="toggleModel" (ngModelChange)="toggle();" [disabled]="this.disabled"/>
    <span class="switcher">
        <span class="trueGreen falseRed">
            <ng-container *ngIf="labels">
                <span>ano</span>
                <span>ne</span>
            </ng-container>
        </span>
    </span>
</label>